import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished'
import { findIndex, filter, sortedUniq, uniq, orderBy} from 'lodash'
import ReactTooltip from 'react-tooltip'

import { updateSettings } from '../../settings'
import { fetchGlossary, getGlossary } from './redux'

import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

class Glossary extends Component {

    state = {

    }
    
    static fetchData(store, match) {
        return store.dispatch(fetchGlossary()); 
    }

    componentDidMount = () => {
        const { updateSettings } = this.props;

        this.props.fetchGlossary()

        updateSettings({
            pageTitle: 'Glossary'
        })
    }

    renderLetters = () => {
        const { glossary } = this.props;

        if (glossary.data) {

            return glossary.data.map((section, i) => {
                const items = section.items.map((item, i) => {
                    return (
                        <Term
                            key={i}
                            data-tip
                            data-for={item.slug}
                        >
                            {item.title}

                            {item.description && (
                                <Tooltip 
                                    id={item.slug} 
                                    type="dark"
                                    place="top"
                                    effect="solid"
                                    container="tooltip"
                                >
                                    <Title>{item.title}</Title>
                                    <Description>{item.description}</Description>
                                </Tooltip>
                            )}
                            
                        </Term>
                    )
                })

                return (
                    <Letter>
                        <Title>{section.letter}</Title>
                        <Items
                            useColumns={items.length > 2}
                        >
                            {items}
                        </Items>
                    </Letter>
                )

            },this)
        } 
    }

  
    render() {

        return (
            <Container>
                
                <Letters>
                    {this.renderLetters()}
                </Letters>
               
            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 65px); 
    ${padding}
    padding-top: 20px;
`

const Title = styled.div``

// Terms container

const Letters = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`   

const Letter = styled.div`
    display: flex;
    margin-bottom: 40px;

    ${media.phone`
        flex-direction: column;
    `}

    > ${Title} {
        flex: 1 0 240px;
        max-width: 240px;
        font-size: 24px;

        ${media.phone`
            font-size: 22px;
            flex: 0 1 auto;
            margin-bottom: 13px;
        `}
    }
`

const Items = styled.div`
    flex: 0 1 auto;
    width: 100%;
    padding-right: 100px;
    max-width: 800px;

    ${props => {
        if (props.useColumns) return css`
            columns: 2;
            column-gap: 260px;
            break-inside: avoid;

            ${media.phone`
                columns: auto;
            `}
        `
    }}
`

// Term

const Term = styled.div``
const Description = styled.div``

// Tooltip

const Tooltip = styled(ReactTooltip)`
    max-width: 422px;
    padding: 15px;
    background-color: black !important;
    border-radius: 0;

    ${Title} {
        color: white;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 4px;
    }

    ${Description}{
        color: white;
        font-size: 16px;
    }

    &::after {
        display: none;
    }


    ${media.phone`
        max-width: calc(100vw - 20px);
        box-sizing: border-box;
    `}
`



const mapDispatchToProps = dispatch => ({
    fetchGlossary() {
        dispatch(fetchGlossary())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    glossary: getGlossary(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Glossary);



// WEBPACK FOOTER //
// ./client/modules/Glossary/Glossary.js